import useConfig from '@/features/configs/useConfig'
import { OfferQuotationStatus } from '@/features/offers/constants'
import { authSelector } from '@/stores/auth/authSlice'
import { Flex, Text, VStack } from '@chakra-ui/react'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import BaseOfferTaskWidget from './BaseOfferTaskWidget'
import OfferTaskButton from './OfferTaskButton'
import { OfferBookingStatus } from '@eapproval/offer-shared'
import { ContributorGroupType } from '@/features/contributorGroups/constants'

const OfferProjectTaskWidget = ({ quotationOffers = [], bookingOffers = [] }) => {
  const { user } = useSelector(authSelector)

  const { useFetchConfigByType } = useConfig()

  const { data: projectViewTeamConfig } = useFetchConfigByType('OFFER_PROJECT_VIEW_TEAM')

  //My Project

  const canViewMyProject = useMemo(() => {
    if (
      !user ||
      !Array.isArray(projectViewTeamConfig?.value) ||
      !Array.isArray(user?.departments) ||
      user.contributorGroup === ContributorGroupType.PROCUREMENT_OFFICER
    ) {
      return false
    }

    return user.departments.some((dept) => projectViewTeamConfig.value.includes(dept))
  }, [quotationOffers.length, bookingOffers.length, projectViewTeamConfig?.value, user])

  if (!canViewMyProject) {
    return <></>
  }

  return (
    <BaseOfferTaskWidget title={'My Project'}>
      <Flex gap="5" direction={['column', 'row']} wrap="wrap">
        <OfferTaskButton
          color="teal"
          buttonText={'Quotation'}
          count={quotationOffers.length}
          link={`/offers/offerProject?salesResponsible=${user.fullName || ''}&status=${Object.values(OfferQuotationStatus).join(',')}`}
          label={
            <VStack>
              {Object.values(OfferQuotationStatus).map((status) => {
                return (
                  <Text key={status}>
                    {status}:{quotationOffers.filter((offer) => offer.status === status).length}
                  </Text>
                )
              })}
            </VStack>
          }
        />
        <OfferTaskButton
          color="blue"
          buttonText={'Booking'}
          count={bookingOffers.length}
          link={`/offers/bookingProject?salesResponsible=${user.fullName || ''}&status=${Object.values(OfferBookingStatus).join(',')}`}
          label={
            <VStack>
              {Object.values(OfferBookingStatus).map((status) => {
                return (
                  <Text key={status}>
                    {status}:{bookingOffers.filter((offer) => offer.status === status).length}
                  </Text>
                )
              })}
              please
            </VStack>
          }
        />
      </Flex>
    </BaseOfferTaskWidget>
  )
}

export default OfferProjectTaskWidget
